module.exports = __webpack_public_path__ + "img/details-desktop-bg2.8ed02999.jpg";